import ApiService from "@/common/api/api.service";
import helpers from "@/common/utils/helpers";

const AprovacaoService = {
  
    listar: function(status = "", porPagina = 0, pagina = 0) {
        return ApiService.get(`AprovacaoUsuario/?Status=${status}&TamanhoDaPagina=${porPagina}&NumeroDaPagina=${pagina}`);
    },

    salvarUsuario: function(form) {
        form.cnpjEmpresa = helpers.removerMascara(form.cnpjEmpresa);
        return ApiService.post(`AprovacaoUsuario`, { ...form });
    },

    buscar : function(id){
        return ApiService.get(`AprovacaoUsuario/${id}`);
    },

    aprovarUsuario: function(form) {
        return ApiService.put(`AprovacaoUsuario/aprovar`, { ...form });
    },

    reprovarUsuario: function(id) {
        return ApiService.put(`AprovacaoUsuario/reprovar?id=${id}`);
    }


};

export default AprovacaoService;
